import { Box } from '@material-ui/core';
import { SText } from '@setvi/shared/components';
import { TextColor } from '@setvi/shared/enums';
import { Pricing, Product } from '@setvi/shared/interfaces';

interface ProfitProps extends Pick<Product, 'price' | 'cost'> {
  label: Pricing['label'];
}

export const Profit = ({ price, cost, label }: ProfitProps) => (
  <Box display="flex">
    <SText
      title={`${label}: ${
        price > cost
          ? (price - cost).toLocaleString('en-US', {
              currency: 'USD',
              style: 'currency'
            })
          : '-'
      }`}
      fontColor={TextColor.DarkGrey}
    />
    {price > cost && (
      <SText
        title={`(${(((price - cost) / price) * 100).toFixed(2).toString()}%)`}
        weight="normal"
        fontColor={TextColor.Green}
        style={{ marginLeft: '5px' }}
      />
    )}
  </Box>
);
